<template>
  <el-progress
    :percentage="progress"
    :text-inside="true"
    :stroke-width="15"
  ></el-progress>
</template>

<script>
export default {
  props: ["dataName", "remove"],
  data() {
    return {
      progress: 0,
      timer: 1,
    };
  },
  mounted() {
    this.progress = 0;
    this.timer = setInterval(this.getProgress, 100);
  },
  destroyed() {
    if (this.remove !== false) {
      console.log('清除数据')
      sessionStorage[this.dataName] = "";
    }
    this.progress = 100;
    clearInterval(this.timer);
  },
  methods: {
    getProgress() {
      // console.log('进度')
      let num = Number(sessionStorage[this.dataName]);
      if (!isNaN(num)) {
        this.progress = parseInt(num);
      }
    },
  },
};
</script>
